export const emptyTypeCode = {
  typeCode: '',
  productCode: '',
  tireSize: '',
  description: '',
  rubberType: '',
};